import i18n from '@/plugins/i18n';

const databaseESGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.available-disk-space-in-bytes'),
      header: {
        title: i18n.global.t('dbm.available-disk-space-in-bytes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_available_disk_space',

      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.cpu-utilization-in'),
      header: {
        title: i18n.global.t('dbm.cpu-utilization-in'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#00c3a5'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cpu_percent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: '%',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: '%',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.memory-free-in-bytes'),
      header: {
        title: i18n.global.t('dbm.memory-free-in-bytes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ee2be1'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_memory_free_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.memory-used-in-bytes'),
      header: {
        title: i18n.global.t('dbm.memory-used-in-bytes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_memory_used_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-io-read-operations'),
      header: {
        title: i18n.global.t('dbm.total-io-read-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ffa100'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_io_total_read_operations',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-operations'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-operations'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.total-io-write-operations'),
      header: {
        title: i18n.global.t('dbm.total-io-write-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_io_total_write_operations',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-operations'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-operations'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.network-bytes-received'),
      header: {
        title: i18n.global.t('dbm.network-bytes-received'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_transport_packets_received_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.network-bytes-sent'),
      header: {
        title: i18n.global.t('dbm.network-bytes-sent'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#cc9858'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_transport_packets_sent_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.open-file-descriptors'),
      header: {
        title: i18n.global.t('dbm.open-file-descriptors'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_open_f_d',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-descriptors'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-descriptors'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-http-connections-currently-open'),
      header: {
        title: i18n.global.t('dbm.number-of-http-connections-currently-open'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#0090ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_http_current_open_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfConnections'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t(
        'dbm.total-number-of-http-connections-opened-over-time',
      ),
      header: {
        title: i18n.global.t(
          'dbm.total-number-of-http-connections-opened-over-time',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#5ec5c7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_http_opened_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfConnections'),
      },
    },
    /*Commenting out this graph, can be taken up in future*/
    // {
    //   width: '48%',
    //   title: 'Threadpool search queue',
    //   header: {
    //     title: 'Threadpool search queue',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#01ce01'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_threadpool_search_queue',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: 'Number of threads'
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: 'Number of threads'
    //   }
    // },
    {
      width: '48%',
      title: i18n.global.t('dbm.threadpool-merge-queue'),
      header: {
        title: i18n.global.t('dbm.threadpool-merge-queue'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f5fe00'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_threadpool_force_merge_queue',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfThreads'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfThreads'),
      },
    },
    /*Commenting out this graph, can be taken up in future*/
    // {
    //   width: '48%',
    //   title: 'Threadpool search rejected',
    //   header: {
    //     title: 'Threadpool search rejected',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#be8ffe'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_threadpool_search_rejected',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: 'Number of threads'
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: 'Number of threads'
    //   }
    // },
    /*Commenting out this graph, can be taken up in future*/
    // {
    //   width: '48%',
    //   title: 'Threadpool merge rejected',
    //   header: {
    //     title: 'Threadpool merge rejected',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#008ffb'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_threadpool_force_merge_rejected',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: 'Number of threads'
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: 'Number of threads'
    //   }
    // },
    {
      width: '48%',
      title: i18n.global.t(
        'dbm.total-count-of-young-generation-garbage-collections',
      ),
      header: {
        title: i18n.global.t(
          'dbm.total-count-of-young-generation-garbage-collections',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_jvm_gc_minor_collections_young_generation_objects',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-gc-collection'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-gc-collection'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t(
        'dbm.total-time-spent-on-young-generation-garbage-collections-ms',
      ),
      header: {
        title: i18n.global.t(
          'dbm.total-time-spent-on-young-generation-garbage-collections-ms',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_jvm_gc_minor_collections_young_generation_objects_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    /*Commenting out this graph, can be taken up in future*/
    // {
    //   width: '48%',
    //   title: 'Total count of old-generation garbage collections',
    //   header: {
    //     title: 'Total count of old-generation garbage collections',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#98ed78'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_jvm_gc_major_collections_old_generation_objects',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: 'Number of GC collection'
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: 'Number of GC collection'
    //   }
    // },
    /*Commenting out this graph, can be taken up in future*/
    // {
    //   width: '48%',
    //   title: 'Total time spent on old-generation garbage collections (ms)',
    //   header: {
    //     title: 'Total time spent on old-generation garbage collections (ms)',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#5ec5c7'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName:
    //     'meter_jvm_gc_major_collections_old_generation_objects_in_milliseconds',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: 'ms'
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: 'ms'
    //   }
    // },
    {
      width: '48%',
      title: i18n.global.t('dbm.heap-memory-used-in'),
      header: {
        title: i18n.global.t('dbm.heap-memory-used-in'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f5fe00'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_jvm_mem_heap_used',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: '%',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: '%',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.heap-memory-used-in-bytes'),
      header: {
        title: i18n.global.t('dbm.heap-memory-used-in-bytes'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_jvm_mem_heap_used_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
    },
  ],
});
export default databaseESGraphs;
